var map = {
	"./devsisters-games.svg": 90467,
	"./download-button/download-icon.svg": 69637,
	"./download-button/highlight-left-top.svg": 66376,
	"./footer/ageNoticeImage.png": 85671,
	"./games/cookierun/background/20190910-cookierun-cookies-mobile.jpg": 49801,
	"./games/cookierun/background/cookierun-cookies-mobile.jpg": 28696,
	"./games/cookierun/background/cookierun-cookies-pc.jpg": 51998,
	"./games/cookierun/card.png": 5939,
	"./games/cookierun/logo/cro-en.png": 15378,
	"./games/cookierun/logo/cro-ja.png": 906,
	"./games/cookierun/logo/cro-ko.png": 72467,
	"./games/cookierun/logo/cro-th.png": 47883,
	"./games/cookierun/logo/cro-zh-Hans.png": 15318,
	"./games/cookierun/logo/cro-zh-Hant.png": 49535,
	"./games/cookierun/opengraph/cookierun-ovenbreak.jpg": 28359,
	"./games/cookierunkingdom/card.png": 46119,
	"./games/cookierunpuzzle/background/cookierunpuzzle-20200109-background-mobile.jpg": 71030,
	"./games/cookierunpuzzle/background/cookierunpuzzle-20200110-background-pc.jpg": 60850,
	"./games/cookierunpuzzle/card.png": 95735,
	"./games/cookierunpuzzle/logo/crp-en.png": 50619,
	"./games/cookierunpuzzle/logo/crp-ja.png": 18835,
	"./games/cookierunpuzzle/logo/crp-ko.png": 7386,
	"./games/cookierunpuzzle/logo/crp-th.png": 97977,
	"./games/cookierunpuzzle/logo/crp-zh-Hant.png": 75197,
	"./games/cookierunpuzzle/opengraph/cookierunpuzzle.jpg": 69595,
	"./games/cookieruntoa/background/cookieruntoa-story1-mobile.jpg": 86591,
	"./games/cookieruntoa/background/cookieruntoa-story1-pc.jpg": 85380,
	"./games/cookieruntoa/background/cookieruntoa-story2-mobile.jpg": 99874,
	"./games/cookieruntoa/background/cookieruntoa-story2-pc.jpg": 68850,
	"./games/cookieruntoa/card.png": 30516,
	"./games/cookieruntoa/logo/toa-en.png": 14894,
	"./games/cookieruntoa/logo/toa-ko.png": 80517,
	"./games/cookieruntoa/opengraph/cookieruntoa.jpg": 2447,
	"./games/ovensmash/background/story1-mobile.png": 91598,
	"./games/ovensmash/background/story1-pc.png": 37181,
	"./games/ovensmash/background/story2-mobile.png": 6446,
	"./games/ovensmash/background/story2-pc.png": 8203,
	"./games/ovensmash/background/story3-mobile.png": 34755,
	"./games/ovensmash/background/story3-pc.png": 87518,
	"./games/ovensmash/background/story4-mobile.png": 29064,
	"./games/ovensmash/background/story4-pc.png": 81376,
	"./games/ovensmash/background/story5-mobile.png": 32830,
	"./games/ovensmash/background/story5-pc.png": 8165,
	"./games/ovensmash/background/story6-mobile.png": 5079,
	"./games/ovensmash/background/story6-pc.png": 75004,
	"./games/ovensmash/card.png": 15543,
	"./games/ovensmash/logo/cos-en.png": 65405,
	"./games/ovensmash/logo/cos-ja.png": 91987,
	"./games/ovensmash/logo/cos-ko.png": 95690,
	"./games/ovensmash/opengraph/ovensmash.jpg": 64969,
	"./games/partypartydecoplay/background/partypartydecoplay-background-mobile.jpg": 77963,
	"./games/partypartydecoplay/background/partypartydecoplay-background-pc.jpg": 24695,
	"./games/partypartydecoplay/card.png": 82043,
	"./games/partypartydecoplay/logo/partypartydecoplay-20200507-logo-ko.png": 59856,
	"./games/partypartydecoplay/opengraph/partypartydecoplay.jpg": 79153,
	"./games/witchscastle/background/witchscastle-story-mobile.jpg": 22484,
	"./games/witchscastle/background/witchscastle-story-pc.jpg": 75873,
	"./games/witchscastle/card.png": 71962,
	"./games/witchscastle/logo/witchscastle-en.png": 93637,
	"./games/witchscastle/logo/witchscastle-ja.png": 46188,
	"./games/witchscastle/logo/witchscastle-ko.png": 13473,
	"./games/witchscastle/logo/witchscastle-th.png": 28527,
	"./games/witchscastle/logo/witchscastle-zh-Hant.png": 10418,
	"./games/witchscastle/opengraph/witchscastle-en.png": 51740,
	"./games/witchscastle/opengraph/witchscastle-ja.png": 92802,
	"./games/witchscastle/opengraph/witchscastle-ko.png": 79851,
	"./games/witchscastle/opengraph/witchscastle-th.png": 8053,
	"./games/witchscastle/opengraph/witchscastle-zh-Hant.png": 32953,
	"./kv/cookierun-20210326-kv-mobile.jpg": 72594,
	"./kv/cookierun-20210326-kv-pc.jpg": 98190,
	"./kv/cookierunpuzzle-20200730-kv-mobile.jpg": 16918,
	"./kv/cookierunpuzzle-20200730-kv-pc.jpg": 86466,
	"./kv/ovenbreak/bg_desktop.jpg": 8820,
	"./kv/ovenbreak/bg_mobile.jpg": 34971,
	"./kv/ovenbreak/kv_mobile_h264.mp4": 49091,
	"./kv/ovenbreak/kv_mobile_hevc.mp4": 9830,
	"./kv/ovenbreak/kv_pc_h264.mp4": 98309,
	"./kv/ovenbreak/kv_pc_hevc.mp4": 46641,
	"./kv/ovenbreak/logo_en.png": 72821,
	"./kv/ovenbreak/logo_ja.png": 8001,
	"./kv/ovenbreak/logo_ko.png": 43934,
	"./kv/ovenbreak/logo_th.png": 95346,
	"./kv/ovenbreak/logo_zh-Hant.png": 70559,
	"./kv/partypartydecoplay-20200507-kv-mobile.jpg": 40372,
	"./kv/partypartydecoplay-20200507-kv-pc.jpg": 17343,
	"./social/bilibili.svg": 15886,
	"./social/discord.svg": 13719,
	"./social/facebook.svg": 81233,
	"./social/forum.svg": 48641,
	"./social/instagram.svg": 77241,
	"./social/naver-cafe.svg": 982,
	"./social/reddit.svg": 49058,
	"./social/tiktok.svg": 85439,
	"./social/twitter.svg": 11928,
	"./social/weibo.svg": 33736,
	"./social/youtube.svg": 28783,
	"./stores/store-apple.de.png": 63675,
	"./stores/store-apple.en.png": 96342,
	"./stores/store-apple.fr.png": 42906,
	"./stores/store-apple.ja.png": 33374,
	"./stores/store-apple.ko.png": 35418,
	"./stores/store-apple.th.png": 1961,
	"./stores/store-apple.zh-hant.png": 84693,
	"./stores/store-galaxy.de.png": 48505,
	"./stores/store-galaxy.en.png": 68907,
	"./stores/store-galaxy.fr.png": 98218,
	"./stores/store-galaxy.ja.png": 2914,
	"./stores/store-galaxy.ko.png": 11758,
	"./stores/store-galaxy.th.png": 60562,
	"./stores/store-galaxy.zh-hant.png": 49467,
	"./stores/store-google.de.png": 49927,
	"./stores/store-google.en.png": 56240,
	"./stores/store-google.fr.png": 57732,
	"./stores/store-google.ja.png": 88341,
	"./stores/store-google.ko.png": 76020,
	"./stores/store-google.th.png": 87472,
	"./stores/store-google.zh-hant.png": 38363,
	"./stores/store-one.en.png": 2593,
	"./stores/store-one.ko.png": 70861,
	"./stores/store-one.zh-hant.png": 59229
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 20945;